export default __webpack_public_path__ + "static/media/cancom.7a90be4b.svg";